module.exports = __webpack_public_path__ + "static/media/mic_icon.59db514a.svg";